export const FALLBACK_SITE_NAME = 'Itronix Electronics';

const normalizeSiteName = (value) => {
  if (typeof value !== 'string') return '';
  const trimmed = value.trim();
  if (!trimmed || trimmed.toLowerCase() === 'null' || trimmed.toLowerCase() === 'undefined') return '';
  return trimmed;
};

export const getLocalizedSiteName = (settings = {}, lang = 'en') => {
  const currentLang = (lang || 'en').substring(0, 2);
  const localizedName = currentLang === 'ar' ? normalizeSiteName(settings.site_name_ar) : '';
  return localizedName || normalizeSiteName(settings.site_name) || FALLBACK_SITE_NAME;
};
